module.exports = __webpack_public_path__ + "img/UI_common_title_help_012_en_3f706c6ea.png";